export enum cards {
    oca = 'OCA',
    visa = 'VISA',
}